<div class="rs-maxh rs-flex rs-flex-dir-col">
  <p>
    <strong>{{ 'publicWifi.accountList.title' | translate }}</strong>
  </p>
  <div class="rs-padding-bottom2">
    <div class="row">
      <div class="columns small-9 end">
        <div class="rs-border rs-padding-bottom1 rs-no-border-top rs-no-border-h">
          <div class="rs-flex-row rs-flex-bottom">
            <div class="rs-flex-column">
              {{ 'publicWifi.accountList.total' | translate }}
            </div>
            <div class="rs-flex-column rs-flex-shrink">{{ total }}</div>
          </div>
        </div>
        <div class="rs-border rs-padding1 rs-no-padding-h rs-no-border-top rs-no-border-h">
          <div class="rs-flex-row rs-flex-bottom">
            <div class="rs-flex-column">
              {{ 'publicWifi.accountList.alreadyUsed' | translate }}
            </div>
            <div class="rs-flex-column rs-flex-shrink">{{ alreadyUsed }}</div>
          </div>
        </div>
        <div class="rs-border rs-padding1 rs-no-padding-h rs-no-border-top rs-no-border-h">
          <div class="rs-flex-row rs-flex-bottom">
            <div class="rs-flex-column">
              {{ 'publicWifi.accountList.remaining' | translate }}
            </div>
            <div class="rs-flex-column rs-flex-shrink">{{ remaining }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rs-flex-grow rs-flex rs-flex-bottom">
    <p class="show-for-medium-up">
      <a href="{{ 'publicWifi.accountList.tnc.link' | translate }}" target="_blank">{{
        'publicWifi.accountList.tnc.label' | translate
      }}</a>
    </p>
  </div>
</div>
